module Bookhus {

    class Queue {
        id: number;
        userId: number;
        startdate: Date;
        enddate: Date;
        cancellationCount: number;
        houses: number[];
    }

    class House {
        id: number;
        title: string;
        hasGooglemaps: boolean;
        userrelationshipLock: string;
        imageId: number;
        enabled: boolean;
        bookinglockDate: Date;
        useBookinglock: boolean;
        attributes: IAttribute[];
        tilsynsførende: number;
        deposit: number;
        imageCopyright: string;
    }

    class CancellationQueueService {
        public queues: Queue[];
        public houses: House[];

        public loadQueues(): JQueryXHR {
            var self = this;
            return $.ajax({
                url: "/api/queuelist/GetQueueListForUser",
                type: "get",
                success: (data: Queue[]) => {
                    self.queues = data;
                    self.queues.forEach((value) => {
                        this.convertDates(value);
                    });
                },
                error: function (xhr: JQueryXHR) {
                    swal.fire({
                        title: 'Der skete en fejl',
                        text: xhr.statusText,
                        icon: 'error'
                    });
                }
            });
        }

        public loadHouses(): JQueryXHR {
            var self = this;
            return $.getJSON('/api/queuelist/GetHouses', (houses: House[]) => {
                self.houses = houses;
            });            
        }

        public deleteQueue(id: number): JQueryXHR {
            return $.ajax({
                url: '/api/queuelist/DeleteQueue?id=' + id,
                type: 'post',
                error: function (xhr: JQueryXHR) {
                    swal.fire({
                        title: 'Der skete en fejl',
                        text: xhr.statusText,
                        icon: 'error'
                    });
                }
            });
        }

        public loadQueue(id: number): JQueryXHR {
            return $.ajax({
                url: '/api/queuelist/GetQueue?id=' + id,
                type: 'get',
                error: function (xhr: JQueryXHR) {
                    swal.fire({
                        title: 'Der skete en fejl',
                        text: xhr.statusText,
                        icon: 'error'
                    });
                }
            });
        }

        public saveQueue(queue: Queue): JQueryXHR {
            return $.ajax({
                url: '/api/queuelist/SaveQueue',
                data: {
                    id: queue.id,
                    userId: queue.userId,
                    startdate: $.datepicker.formatDate("yy-mm-dd", queue.startdate),
                    enddate: $.datepicker.formatDate("yy-mm-dd", queue.enddate),
                    cancellationCount: queue.cancellationCount,
                    houses: queue.houses
                },
                type: 'post',
            });
        }

        public convertDates(queue: Queue): void {
            if (typeof (queue.startdate) == "string") {
                queue.startdate = this.dateFromString(queue.startdate as string);
            }
            if (typeof (queue.enddate) == "string") {
                queue.enddate = this.dateFromString(queue.enddate as string);
            }
        }

        public checkDateSpan(startDate: Date, endDate: Date): Result {
            
            var today = new Date().getDateWithoutTime();
            var maxDurationInMiliseconds = 365 * 24 * 60 * 60 * 1000;

            if (endDate.getTime() < startDate.getTime()) {
                return new Result("Start dato må ikke være større end slut dato", true);
            }

            if (endDate.getTime() < today.getTime() || startDate.getTime() < today.getTime()) {
                return new Result("Hverken start eller slut dato må være før dags dato", true);
            }

            if (endDate.getTime() - startDate.getTime() > maxDurationInMiliseconds) {
                return new Result("Det valgte datospænd må ikke være større en 365 dage", true);
            }

            if (endDate.getTime() - today.getTime() > maxDurationInMiliseconds) {
                return new Result("Slut dato må ikke være længere end 365 dage ud i fremtiden", true);
            }

            return new Result("Alt ok");
        }

        private dateFromString(str: string): Date {
            var a = $.map(str.split(/[^0-9]/), function (s) { return parseInt(s, 10) });
            return new Date(a[0], a[1] - 1 || 0, a[2] || 1, a[3] || 0, a[4] || 0, a[5] || 0, a[6] || 0);
        }
    }

    class Result {
        public error: boolean;
        public message: string;

        constructor(message = "", error = false) {
            this.error = error;
            this.message = message;
        }
    }


    export class CancellationQueue {

        private listContainer: JQuery;
        private buttonContainer: JQuery;
        private modalContainer: JQuery;
        private queueService: CancellationQueueService;
        private disallowNonePeriodsForWaitingList: boolean;
        

        constructor(listContainer: string, buttonContainer: string, disallowNonePeriodsForWaitingList: boolean) {
            var self = this;
            self.listContainer = $(listContainer);
            self.buttonContainer = $(buttonContainer);
            self.disallowNonePeriodsForWaitingList = disallowNonePeriodsForWaitingList;
            self.queueService = new CancellationQueueService();
            self.init();
        }

        init():void {
            var self = this;

            $.when(self.queueService.loadQueues(), self.queueService.loadHouses()).then(() => {
                self.renderList();
                self.renderButton();
                self.renderModal();
                self.events();
            });
        }

        renderList(): void {
            var self = this;

            var queues = "";

            for (var i = 0; i < self.queueService.queues.length; i++) {
                var current = self.queueService.queues[i];
                var currentHouse = self.getHouse(current.houses[0]);

                if (currentHouse == null) {
                    continue;
                }

                /*${(current.Houses.length > 1 ? "/Content/siteimages/houseIcon.png" : "/houseimage/" + currentHouse.ImageId + "/150")}
    */
                

                queues += `
<div class="col-md-6 queueItem" id="queue_${current.id}" style="margin-top: 20px;" data-index="${i}">    
    
    <div class="rowcontainer">                
        <div class="col-sm-3 col-md-5 col-lg-4">
            <div class="photo" style="background-image: url(/houseimage/${currentHouse.imageId}); background-size: cover; background-repeat: no-repeat; width: 150px; height: 150px;"></div>
        </div>
        <div class="col-sm-9 col-md-7 col-lg-8">
            <h4>${currentHouse.title}</h4>
            <p>${current.startdate.toString("dd-MM-yyyy")} til ${current.enddate.toString("dd-MM-yyyy")}</p>
            <p>Der er ${current.cancellationCount} afbud</p>
            <div data-id="${current.id}">
                <button data-command="show" class="btn btn-default btn-subtle-primary">Se afbud</button>
                ${self.disallowNonePeriodsForWaitingList ? '' : '<button data-command="edit" class="btn btn-default btn-subtle-primary">Rediger</button>'}
                <button data-command="delete" class="btn btn-default btn-subtle-danger">Slet</button>
            </div>            
        </div>
    </div>
    [CONTROLS]

</div>`;
                queues = queues.replace("[CONTROLS]", current.houses.length > 1 ? `<span class="fa fa-chevron-left arrow left"></span>
                <span class="fa fa-chevron-right arrow right"></span>` : "");
            }


            

            var html = `
<div class="row">
${queues}
</div>

`;
            self.listContainer.html(html);
        }

        renderButton(): void {
            var self = this;
            var html = `<button type="button" class="btn btn-default btn-subtle-primary">Tilmeld venteliste</button>`
            self.buttonContainer.html(html);
        }

        renderModal(): void {
            var self = this;

            var houses = "";

            for (var i = 0; i < self.queueService.houses.length; i++) {
                houses += `<option value="${self.queueService.houses[i].id}">${self.queueService.houses[i].title}</option>`;
            }


            var html = `

<div class="modal fade" id="editQueueModal" tabindex="-1" role="complementary" aria-label="Rediger afbud venteliste">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Rediger</h5>
            </div>
            <div class="modal-body">
                <label id="errorMessage" style="color: red; display: none; font-style: italic;"></label>
                <input type="hidden" name="id"/>
                <div class="form-group">
                    <label>Startdato</label><br/>
                    <input type="text" name="startdate" class="form-control customDatePicker" />
                </div>
                <div class="form-group">
                    <label>Slutdato</label><br/>
                    <input id="enddate" name="enddate" type="text" class="form-control customDatePicker" />
                </div>
                <div class="form-group">
                    <select multiple="true" name="houses" class="form-control">${houses}</select>
                </div>
            </div>
            <div class="modal-footer">
                <button data-command="saveperiod" type="button" class="btn btn-primary">Gem ændringer</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuller</button>
            </div>
        </div>
    </div>
</div>

`;
            $('body').append(html);
            self.modalContainer = $('#editQueueModal');
        }

        events(): void {
            var self = this;

            self.buttonContainer.find('button').on('click', () => {
                var temp = new Queue();
                temp.id = 0;
                temp.startdate = null;
                temp.enddate = null;
                temp.houses = [];
                self.openModal(temp);
            })

            self.listContainer.on('click', '[data-command]', function (e) {
                var element = $(e.target)
                switch (element.attr('data-command')) {
                    case 'delete':
                        swal.fire({
                            title: 'Er du sikker?',
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonText: 'Annuller'
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                var id = parseInt(element.parent().attr('data-id'));
                                self.queueService.deleteQueue(id).then(() => {
                                    self.removeElement(id);
                                });
                            }
                        });
                        break;
                    case 'show':
                        var id = parseInt(element.parent().attr('data-id'));
                        self.queueService.loadQueue(id).then((data: Queue) => {
                            self.queueService.convertDates(data);
                            location.href = `/booking/cancellationlist?arrivalDate=${data.startdate.toString("dd-MM-yyyy HH:mm")}&departureDate=${data.enddate.toString("dd-MM-yyyy HH:mm")}&houseIds=${data.houses.join(',')}`
                        });
                        break;
                    case 'edit':
                        var id = parseInt(element.parent().attr('data-id'));
                        self.queueService.loadQueue(id).then((data) => {
                            self.queueService.convertDates(data);
                            self.openModal(data as Queue, "Rediger periode")
                        });
                        break;
                }
            });

            self.modalContainer.on('click', '[data-command]', function (e) {
                var element = $(e.target)
                switch (element.attr('data-command')) {
                    case 'saveperiod':
                        var data = {} as Queue;
                        $(self.modalContainer.find('input, select, textarea')).each((index, element) => {
                            var current = $(element);
                            if (current.attr('name') == undefined || current.val() == null) {
                                return;
                            }
                            if (current.prop('type') == "checkbox") {
                                data[current.attr('name')] = current.is(':checked');
                            }
                            else if (current.hasClass('customDatePicker')) {
                                data[current.attr('name')] = current.datepicker('getDate') as Date;
                            }
                            else {
                                data[current.attr('name')] = current.val();
                            }
                        });

                        var result = self.queueService.checkDateSpan(data.startdate, data.enddate);
                        if (result.error) {
                            $('#errorMessage').html(result.message);
                            $('#errorMessage').css('display', 'block');
                            return;
                        }

                        self.queueService.saveQueue(data as Queue).then(() => {
                            self.queueService.loadQueues().then(() => {
                                self.renderList();
                            });
                            self.modalContainer.modal('hide');
                        }).fail(function (xhr: JQueryXHR) {
                            self.modalContainer.modal('hide');
                            console.log(xhr);
                            swal.fire({
                                title: 'Der skete en fejl',
                                text: xhr.statusText,
                                icon: 'error'
                            });
                        });
                        break;
                }
            });

            self.listContainer.on('click', 'span.arrow', function (e) {               
                var element = $(e.target);
                var parent = element.parent();
                var queue = self.getQueue(parseInt(parent.attr('data-index')));
                if (queue == null) {
                    return;
                }

                var direction = element.hasClass('glyphicon-chevron-right') ? 1 : -1;
                var newIndex = (parent.prop('hIndex') || 0) + direction;
                
                if (newIndex < 0) {
                    newIndex = queue.houses.length - 1;
                }
                if (newIndex > queue.houses.length - 1) {
                    newIndex = 0;
                }

                var houseId = queue.houses[newIndex];
                var house = self.getHouse(houseId);
                
                if (house == null) {
                    return;
                }

                parent.find("h4").html(house.title);
                parent.find(".photo").css('background-image', `url(/houseimage/${house.imageId})`)

                parent.prop('hIndex', newIndex);                
            });

            $(".customDatePicker").datepicker(
                {
                    buttonImage: "/content/siteimages/calendar31.png",
                    buttonImageOnly: true,
                    buttonText: "Klik for at åbne en kalender",
                    /*dateFormat: 'yy-mm-dd',
                    dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                    dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                    dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                    monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
                    /*dateFormat: 'dd-mm-yy',*/
                    constrainInput: true,
                    showOn: 'button',
                    firstDay: 1,
                    showWeek: true,
                    changeYear: true,
                    changeMonth: true,
                    /*weekHeader: 'Uge',*/
                    yearRange: '2013:+36',
                    altFormat: 'yy-mm-dd',
                    minDate: 0,
                    maxDate: 365
                });

            var search = location.search.substring(1);
            var cridentials = search.length > 0 ? JSON.parse('{"' + decodeURIComponent(search).replace(/&/g, '","').replace(/=/g, '":"') + '"}') : {};

            for (var key in cridentials) {
                if (!cridentials.hasOwnProperty(key)) {
                    continue;
                }
                if (key == "opencancellation" && cridentials[key] == "true") {
                    self.buttonContainer.find('button').click();
                }
            }

            

        }

        getHouse(houseId: number): House {
            var self = this;
            for (var i = 0; i < self.queueService.houses.length; i++) {
                var current = self.queueService.houses[i];
                if (current.id == houseId) {
                    return current;
                }
            }
            return null;
        }

        getDate(date: string): Date {
            if (date == null) {
                return new Date();
            }

            var match = date.match(/\d+/g)[0];
            if (match.length > 0) {
                return new Date(parseInt(match));
            }
            return new Date();
        }

        removeElement(id: number) {
            $("#queue_" + id).remove();
        }

        openModal(data: Queue, title: string = "Opret ny periode") {
            var self = this;

            self.modalContainer.find('.modal-title').html(title);
            self.modalContainer.find('input[name=id]').val(data.id.toString());

            self.modalContainer.find('input[name=startdate]').val(data.startdate == null ? "" : data.startdate.toString("dd-MM-yyyy"));
            self.modalContainer.find('input[name=enddate]').val(data.enddate == null ? "" : data.enddate.toString("dd-MM-yyyy"));
            $('#errorMessage').html('');
            $('#errorMessage').css('display', 'none');


            var houselist = self.modalContainer.find('select[name=houses]')
            houselist.find('option').prop('selected', false);
            for (var i = 0; i < data.houses.length; i++) {
                houselist.find(`option[value=${data.houses[i]}]`).prop('selected', true);                
            }

            self.modalContainer.modal('show');
        }

        getQueue(index: number) {
            var self = this;
            if (index > self.queueService.queues.length || index < 0) {
                return null;
            }
            return self.queueService.queues[index];
        }
    }
}